import React from 'react';

const DeleteConfirmationDialog = ({ isOpen, onCancel, onConfirm }) => {
  return (
    <div className={`fixed inset-0 flex items-center justify-center ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
      <div className="absolute inset-0 bg-gray-900 opacity-75" />
      <div className="bg-white rounded-lg p-8 max-w-md mx-auto z-50">
        <h2 className="text-lg font-semibold mb-4">Delete Jobs</h2>
        <p className="text-gray-700 mb-4">Are you sure you want to delete this Jobs?</p>
        <div className="flex justify-end">
          <button className="bg-red-500 text-white px-4 py-2 rounded mr-2" onClick={onConfirm}>
            Delete
          </button>
          <button className="bg-gray-300 text-gray-800 px-4 py-2 rounded" onClick={onCancel}>
            Cancel
          </button>
        </div>
         <h1 className='pt-3 text-red-500'> Note: After delete you will loose this data </h1>
      </div>
    </div>
  );
};

export default DeleteConfirmationDialog;